<script setup>
import ProjectCard from './ProjectCard.vue'

defineProps({
  projects: {
    type: Array,
    required: true,
  },
})
</script>

<template>
  <div class="projects-grid">
    <!-- [
            {
              "id": 1,
              "title": "Проект 1",
              "category": "BROADCAST",
              "date": "2024-01-01 12:00:00",
              "content": "Содержание проекта",
              "cover_url": "https://example.com/cover.webp",
              "short_video_url": "https://example.com/short_video.mp4",
              "users": [
                {
                  "role": "Продюсер",
                  "user": {
                    "description": "Продюсер",
                    "id": "fyakushkin",
                    "title": "Федор Якушкин"
                  }
                },
                {
                  "role": "Режиссёр",
                  "user": {
                    "description": "Режиссёр",
                    "id": "dshvedov",
                    "title": "Даниил Шведов"
                  }
                }
              ],
              "created_at": "2024-01-01 12:00:00",
              "updated_at": "2024-01-01 12:00:00"
            }
          ]-->
    <ProjectCard
      v-for="project in projects"
      :key="project.id"
      size="sm"
      :title="project.title"
      :category="project.category"
      :link="'/project/' + project.id"
      :image_url="project.cover_url"
      :video_url="project.short_video_url"
    />
  </div>
</template>

<style scoped>
.projects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(18.75rem, 1fr));
  gap: 0.625rem;
  width: 100%;
  padding: 2.5rem 0;
}

@media (max-width: 64rem) {
  .projects-grid {
    gap: 1.25rem;
  }
}

@media (max-width: 48rem) {
  .projects-grid {
    grid-template-columns: 100%;
    gap: 1.25rem;
  }
}
</style>
